import { useEffect, useState } from "react";
import { keyframes } from "@emotion/react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Badge,
  Spacer,
  Box,
  useBreakpointValue,
  Heading,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Checkbox,
  Text,
  Spinner,
  VStack,
} from "@chakra-ui/react";

import TableGrid from "components/Table";
import { useImmer } from "use-immer";
import { ITableHeader } from "Interfaces/Components/TableGrid";
import PurchaseSupplierSkusHeader from "variables/Header/PurschaseSupplierSkus";
import { parsePurchaseSupplierSkus } from "helpers/Grid/PurchaseSupplierSkusParse";
import usePurchaseSupplier from "hooks/Supplier/use-purchase";
import PurchaseSupplierSkusGridMobile from "components/Table/Responsive/PurcahaseSupplierSkus";
import LoadingComponent from "components/Main/Loading";
import PurchaseSupplierSkusResumeHeader from "variables/Header/PurschaseSupplierSkusResume";
import { parsePurchaseSupplierSkusResume } from "helpers/Grid/PurchaseSupplierSkusResumeParse";
import useScheduleSupplier from "hooks/Supplier/use-schedule-supplier";
import dayjs from "dayjs";

const ModalSkus = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [headers1] = useImmer<ITableHeader[]>(PurchaseSupplierSkusHeader);
  const [headersResume] = useImmer<ITableHeader[]>(
    PurchaseSupplierSkusResumeHeader
  );
  const {
    dataSkus,
    getSkus,
    idSelectDateSkus,
    idSelectDate,
    loadingSkus,
    handleRemoveCheckboxChangeSkus,
  } = usePurchaseSupplier();

  const {
    getScheduleAvaliableDateById,
    loadingAvaliableData,
    datesAvaliable,
    confirmReSchedule,
    loading,
  } = useScheduleSupplier();
  const [step, setStep] = useState(1);
  const [productManager, setProductManaer] = useState(null);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const bgLoading = useColorModeValue("white", "#111C44");

  const onClose = () => {
    setStep(1);
    handleRemoveCheckboxChangeSkus();
    setIsOpen(false);
  };
  const onOpen = () => setIsOpen(true);

  const steps = [
    { title: "First", description: "Contact Info" },
    { title: "Second", description: "Date & Time" },
    { title: "Third", description: "Select Rooms" },
  ];

  useEffect(() => {
    if (isOpen) {
      getSkus();
    }
  }, [isOpen]);

  const getAvaliables = () => {
    var selecteds = dataSkus.filter((item) => {
      const result = idSelectDateSkus.some(
        (selectedItem) =>
          selectedItem.id === item.productId &&
          selectedItem.documentId === item.documentId
      );
      return result;
    });

    getScheduleAvaliableDateById(
      selecteds[0].productId,
      selecteds[0].documentId,
      selecteds[0].supplierId
    );
  };

  const getDayOfWeek = (dateInput: string): string => {
    const date = new Date(dateInput);
    const daysOfWeek = [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ];
    // date.setDate(date.getDate() + 1);
    const dayOfWeekIndex = date.getDay();
    return daysOfWeek[dayOfWeekIndex];
  };
  const [selectedId, setSelectedId] = useState(null);

  const handleCheckboxChange = (id: any) => {
    setSelectedId((prevSelectedId: any) => (prevSelectedId === id ? null : id));
  };

  const handleConfirmarAgendamento = () => {
    // Lógica de confirmação de agendamento aqui
    var selecteds = dataSkus.filter((item) => {
      const result = idSelectDateSkus.some(
        (selectedItem) =>
          selectedItem.id === item.productId &&
          selectedItem.documentId === item.documentId
      );
      return result;
    });
    const arraySelecteds = selecteds.map((item) => ({
      productId: item.productId,
      documentId: item.documentId,
      supplierId: item.supplierId,
      orderedQuantity: item.orderedQuantity,
      receivedQuantity: item.receivedQuantity,
      schedulingQuantity: item.quantitySchedule,
      pendingQuantity: item.quantityPendingScheduling,
    }));
    const valueStore = JSON.parse(localStorage.getItem("storeUser"));
    const obj = {
      schedules: arraySelecteds,
      dateAvailable: selectedId,
    };

    confirmReSchedule(obj);
    setProductManaer(null);
  };

  return (
    <div>
      <Button
        onClick={onOpen}
        isDisabled={idSelectDate.length === 0}
        variant="outline"
        colorScheme="teal"
        ml={2}
      >
        Ver SKUs
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          step === 1 ? onClose() : setStep(step - 1);
        }}
        size={step === 3 ? "md" : "12xl"}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent position="relative">
          {loading && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bg="blackAlpha.700"
              zIndex={10}
              borderRadius={5}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <VStack spacing={5}>
                <Spinner
                  size="xl"
                  color="green.300"
                  thickness="4px"
                  speed="0.7s"
                  emptyColor="whiteAlpha.300"
                />
                <Text
                  color="white"
                  fontWeight="700"
                  fontSize="lg"
                  textAlign="center"
                  sx={{
                    animation: `${keyframes`
                      0%, 100% { opacity: 1; }
                      50% { opacity: 0.4; }
                    `} 1.5s ease-in-out infinite`,
                  }}
                >
                  Seu agendamento está sendo processado...
                </Text>
                <Text color="whiteAlpha.700" fontSize="sm" textAlign="center">
                  Por favor, aguarde
                </Text>
              </VStack>
            </Box>
          )}
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            {step === 1
              ? "  FORNECEDORES - SKUS"
              : step === 2
              ? "FORNECEDORES - NOVO AGENDAMENTO"
              : "CONFIRMAR AGENDAMENTO"}
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <Flex
              px="25px"
              mb="8px"
              justifyContent="space-between"
              align="center"
            >
              {step === 1 && (
                <>
                  <Badge variant="subtle" colorScheme="blue" ml={2}>
                    {idSelectDateSkus.length}
                  </Badge>
                  {"\u00A0"}
                  <span> itens selecionados</span>
                  <Spacer />

                  <Button
                    variant="outline"
                    isDisabled={idSelectDateSkus.length === 0}
                    colorScheme="teal"
                    onClick={() => setStep(2)}
                    ml={2}
                  >
                    Agendar
                  </Button>
                </>
              )}
              {step === 2 && (
                <>
                  <Button
                    variant="outline"
                    isDisabled={idSelectDateSkus.length === 0}
                    colorScheme="teal"
                    onClick={() => setStep(1)}
                    ml={2}
                  >
                    Voltar
                  </Button>

                  <Spacer />

                  <Button
                    variant="outline"
                    isDisabled={idSelectDateSkus.length === 0}
                    colorScheme="teal"
                    onClick={() => {
                      setStep(3);
                      getAvaliables();
                    }}
                    ml={2}
                  >
                    {isMobile
                      ? "Escolher Data"
                      : "    Escolher Data de Agendamento"}
                  </Button>
                </>
              )}
              {step === 3 && (
                <>
                  <Button
                    variant="outline"
                    isDisabled={idSelectDateSkus.length === 0}
                    colorScheme="teal"
                    onClick={() => setStep(1)}
                    ml={2}
                  >
                    Voltar
                  </Button>

                  <Spacer />

                  <Button
                    variant="outline"
                    isDisabled={selectedId === null || loading}
                    colorScheme="teal"
                    onClick={() => {
                      handleConfirmarAgendamento();
                    }}
                    ml={2}
                  >
                    Confirmar Agendamento
                  </Button>
                </>
              )}
            </Flex>
            <Box pt={6}>
              {step === 1 && (
                <>
                  {loadingSkus ? (
                    <>
                      <Box bg={bgLoading}>
                        <LoadingComponent spinnerSize="50vh" />
                      </Box>
                    </>
                  ) : (
                    <>
                      {isMobile ? (
                        <>
                          {dataSkus.length === 0 ? (
                            <>
                              <Box bg={bgLoading} borderRadius="2%">
                                <Flex
                                  flexDir="column"
                                  alignItems="center"
                                  justifyContent="center"
                                  bg="white.600"
                                  borderRadius="8px"
                                  h="calc(70vh - 8px)"
                                  p={6}
                                >
                                  <Heading
                                    mb={5}
                                    textAlign="center"
                                    fontSize={["20px", "20px", "30px"]}
                                    fontWeight="800"
                                    color="green.600"
                                  >
                                    {"Nenhum dado encontrado"}
                                  </Heading>
                                </Flex>
                              </Box>
                            </>
                          ) : (
                            <>
                              <Box overflow="auto" maxHeight={400}>
                                <PurchaseSupplierSkusGridMobile
                                  header={headers1}
                                  data={dataSkus.filter(
                                    (item) => item.quantityPendingScheduling > 0
                                  )}
                                />
                              </Box>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {dataSkus.length === 0 ? (
                            <>
                              <Box bg={bgLoading} borderRadius="2%">
                                <Flex
                                  flexDir="column"
                                  alignItems="center"
                                  justifyContent="center"
                                  bg="white.600"
                                  borderRadius="8px"
                                  h="calc(70vh - 8px)"
                                  p={6}
                                >
                                  <Heading
                                    mb={5}
                                    textAlign="center"
                                    fontSize={["20px", "20px", "30px"]}
                                    fontWeight="800"
                                    color="green.600"
                                  >
                                    {"Nenhum dado encontrado"}
                                  </Heading>
                                </Flex>
                              </Box>
                            </>
                          ) : (
                            <>
                              <TableGrid
                                id="purchase-supplier-skus"
                                headers={headers1}
                                data={parsePurchaseSupplierSkus(
                                  dataSkus.filter(
                                    (item) => item.quantityPendingScheduling > 0
                                  )
                                )}
                                itsSortable={true}
                                entity="purchase-supplier-skus"
                                height={"620px"}
                              />
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
              {step === 2 && (
                <>
                  {loadingSkus ? (
                    <>
                      <Box bg={bgLoading}>
                        <LoadingComponent spinnerSize="50vh" />
                      </Box>
                    </>
                  ) : (
                    <>
                      {isMobile ? (
                        <>
                          {dataSkus.length === 0 ? (
                            <>
                              <Box bg={bgLoading} borderRadius="2%">
                                <Flex
                                  flexDir="column"
                                  alignItems="center"
                                  justifyContent="center"
                                  bg="white.600"
                                  borderRadius="8px"
                                  h="calc(70vh - 8px)"
                                  p={6}
                                >
                                  <Heading
                                    mb={5}
                                    textAlign="center"
                                    fontSize={["20px", "20px", "30px"]}
                                    fontWeight="800"
                                    color="green.600"
                                  >
                                    {"Nenhum dado encontrado"}
                                  </Heading>
                                </Flex>
                              </Box>
                            </>
                          ) : (
                            <>
                              <Box overflow="auto" maxHeight={400}>
                                <PurchaseSupplierSkusGridMobile
                                  header={headers1}
                                  data={dataSkus.filter((item) => {
                                    const result = idSelectDateSkus.some(
                                      (selectedItem) =>
                                        selectedItem.id === item.productId &&
                                        selectedItem.documentId ===
                                          item.documentId
                                    );
                                    return result;
                                  })}
                                />
                              </Box>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {dataSkus.length === 0 ? (
                            <>
                              <Box bg={bgLoading} borderRadius="2%">
                                <Flex
                                  flexDir="column"
                                  alignItems="center"
                                  justifyContent="center"
                                  bg="white.600"
                                  borderRadius="8px"
                                  h="calc(70vh - 8px)"
                                  p={6}
                                >
                                  <Heading
                                    mb={5}
                                    textAlign="center"
                                    fontSize={["20px", "20px", "30px"]}
                                    fontWeight="800"
                                    color="green.600"
                                  >
                                    {"Nenhum dado encontrado"}
                                  </Heading>
                                </Flex>
                              </Box>
                            </>
                          ) : (
                            <>
                              <TableGrid
                                id="purchase-supplier-skus-resume"
                                headers={headersResume}
                                data={parsePurchaseSupplierSkusResume(
                                  dataSkus.filter((item) => {
                                    const result = idSelectDateSkus.some(
                                      (selectedItem) =>
                                        selectedItem.id === item.productId &&
                                        selectedItem.documentId ===
                                          item.documentId
                                    );
                                    return result;
                                  })
                                )}
                                itsSortable={true}
                                entity="purchase-supplier-skus-resume"
                                height={"420px"}
                              />
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
              {step === 3 && (
                <>
                  {loadingAvaliableData ? (
                    <>
                      <Box bg={bgLoading}>
                        <LoadingComponent spinnerSize="50vh" />
                      </Box>
                    </>
                  ) : (
                    <>
                      <>
                        {dataSkus.length === 0 ? (
                          <>
                            <Box bg={bgLoading} borderRadius="2%">
                              <Flex
                                flexDir="column"
                                alignItems="center"
                                justifyContent="center"
                                bg="white.600"
                                borderRadius="8px"
                                h="calc(70vh - 8px)"
                                p={6}
                              >
                                <Heading
                                  mb={5}
                                  textAlign="center"
                                  fontSize={["20px", "20px", "30px"]}
                                  fontWeight="800"
                                  color="green.600"
                                >
                                  {"Nenhum dado encontrado"}
                                </Heading>
                              </Flex>
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box overflow="auto" maxHeight={400}>
                              <>
                                <Table>
                                  <Thead>
                                    <Tr
                                      bg="gray.200"
                                      color="black"
                                      fontWeight="700"
                                    >
                                      <Th></Th>
                                      <Th color="black" fontWeight="700">
                                        Data Prevista
                                      </Th>
                                      <Th color="black" fontWeight="700">
                                        Dia da Semana
                                      </Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {/* mock */}
                                    {datesAvaliable.map((item: any) => (
                                      <Tr>
                                        <Td>
                                          <Checkbox
                                            onChange={() => {
                                              handleCheckboxChange(
                                                item.dateAvailable
                                              );
                                              setProductManaer(
                                                item.productManagerId
                                              );
                                            }}
                                            colorScheme="blue"
                                            borderColor="blackAlpha.400"
                                            isChecked={
                                              selectedId === item.dateAvailable
                                            }
                                          />
                                        </Td>
                                        <Td>
                                          {dayjs(item.dateAvailable).format(
                                            "DD/MM/YYYY "
                                          )}
                                        </Td>
                                        <Td>
                                          {getDayOfWeek(item.dateAvailable)}
                                        </Td>
                                      </Tr>
                                    ))}
                                    {/* <Tr>
                                        <Td>
                                          <Checkbox />
                                        </Td>
                                        <Td>10/10/2023</Td>
                                        <Td>Sexta</Td>
                                      </Tr>
                                      <Tr>
                                        <Td>
                                          <Checkbox />
                                        </Td>
                                        <Td>13/10/2023</Td>
                                        <Td>Domingo</Td>
                                      </Tr> */}
                                  </Tbody>
                                </Table>
                              </>
                            </Box>
                          </>
                        )}
                      </>
                    </>
                  )}
                </>
              )}
            </Box>
          </ModalBody>

          <ModalFooter>
            {/* Adicione mais botões de ação conforme necessário */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ModalSkus;
